import service from '@/store/services/fms/vehicle-service';

const state = {
  list: {},
  fms_vehicle: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => { 
    state.list = list;
  },
  SET_RESOURCE: (state, fms_vehicle) => {
    state.fms_vehicle = fms_vehicle;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((fms_vehicle) => { commit('SET_RESOURCE', fms_vehicle); });
  },


  add({commit, dispatch}, params) {
    return service.add(params)
      .then((fms_vehicle) => { commit('SET_RESOURCE', fms_vehicle); });
  },

  get_mileage_mspf({commit, dispatch}, params) {
    return service.get_mileage_mspf(params)
      .then((fms_vehicle) => { commit('SET_RESOURCE', fms_vehicle); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((fms_vehicle) => { commit('SET_RESOURCE', fms_vehicle); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  fms_vehicle: state => state.fms_vehicle,
  page: state => state.meta.page,

};
 
const fms_vehicle = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default fms_vehicle;
